import React from "react";
import InsideHeader from "../../components/InsideHeader";
import CreditTable from "./CreditTable";

function CreditList() {
  return (
    <div className="w-full h-full overflow-y-auto weiser-soft-scrollbar">
      <InsideHeader
        title="Credit"
        subtitle="Load and manage reseller credit."
        back={false}
        compact={true}
      />

      <div className="lg:px-10 px-3 pt-4 pb-6">
        <CreditTable />
      </div>
    </div>
  );
}

export default CreditList;
